const A = 20;
export {
  A as MAX_EXTRA_AMOUNT
};
